module.exports = __webpack_public_path__ + "assets/img/title-6c28146e.png";